<template>
  <div>
    <v-btn v-show="enableAutofill" color="success" x-small style="text-transform: none;" @click="autofillHandler">auto-fill</v-btn>
    <auto-form v-model="fields" :mode="mode" :forcedUpdate="forcedUpdate"></auto-form>
  </div>
</template>

<script>

import AutoForm from '@/components/CommonView/AutoForm.vue';
import * as moment from "moment/moment";
import { view } from './header'
export default {
  props: {
    item: {
      type: Object
    },
    mode: {
      type: String,
      default: 'view'
    }
    
  },
  components: {
    AutoForm
  },
  computed: {
    enableAutofill() {
      var code = this.fields.find(x=>x.name=='code').value
      let codeParts = code?.split('_')
      if(codeParts?.length===2) {
        return true
      }else return false
    },

    fields: {
      get() {
        return [
          {name: 'code', label:'Mã', type: 'text-field', value: this.item?.code, placeholder:'Module_Permission', cols: 6 },
          {name: 'alias', label:'Alias', type: 'text-field', value: this.item?.alias, cols: 12, md:6 },
          {name: 'name', label:'Tên', type: 'text-field', value: this.item?.name, cols: 12, md:6 },
          {name: 'slug', label:'slug', type: 'text-field', value: this.item?.slug, cols: 12, md:6 },
          {name: 'groupName', label:'Tên nhóm', type: 'text-field', value: this.item?.groupName, cols: 12, md:12 },
          {name: 'groupSlug', label:'Tên nhóm slug', type: 'text-field', value: this.item?.groupSlug, cols: 12, md:12 },
          {name: 'parentCode', label:'Parent', type: 'text-field', value: this.item?.parentCode, cols: 12, md:12 },
        ]
      },
      set(value) {
        if(value) {
          this.$emit('input', value);
        }
      }
    },
    
    viewHeaders () {
      return view([])
    }
  },
  data() {
    return {
      forcedUpdate: false
      // slots: ['score']
    }
  },
  watch: {
    // item(newVal, oldVal) {
    //   console.log('watcher:', newVal, oldVal)
    // }
  },
  methods: {
    forcedUpdateTrigger() {
      this.forcedUpdate = !this.forcedUpdate
    },
    autofillHandler() {
      var code = this.fields.find(x=>x.name=='code').value
      let codeParts = code.split('_');
      this.fields.find(x=>x.name=='alias').value = codeParts[0]?.toLowerCase() + '-' + codeParts[1]?.toLowerCase()
      this.fields.find(x=>x.name=='name').value = codeParts[0] + ' ' + codeParts[1]
      this.fields.find(x=>x.name=='slug').value = codeParts[0]?.toLowerCase() + ':' + codeParts[1]?.toLowerCase()
      this.fields.find(x=>x.name=='groupName').value = codeParts[0]
      this.fields.find(x=>x.name=='groupSlug').value = codeParts[0]?.toLowerCase()
      this.fields.find(x=>x.name=='parentCode').value = codeParts[0]?.toLowerCase() + ':' + 'index'
      this.forcedUpdateTrigger();
    }

  }

}
</script>